import { t } from '@lingui/core/macro';

import type {
  KPINotificationType,
  PageMetaNotificationNameType,
} from '@/api/settings/settingsType';

type ChannelKPINameType =
  | 'channel-total-visits'
  | 'channel-total-spend'
  | 'channel-spend-per-visit'
  | 'channel-target-visits'
  | 'channel-target-spend-per-visit';

export const channelGoalKPIs = (): Partial<
  Record<PageMetaNotificationNameType, KPINotificationType<ChannelKPINameType>[]>
> => ({
  channel: [
    { value: 'channel-total-visits', label: t`Total Visits`, allowsAudience: false },
    { value: 'channel-total-spend', label: t`Total Spend`, allowsAudience: false },
    {
      value: 'channel-spend-per-visit',
      label: t`Audience Spend Per Visit`,
      allowsAudience: false,
    },
    {
      value: 'channel-target-visits',
      label: t`Audience Visits`,
      allowsAudience: false,
    },
    {
      value: 'channel-target-spend-per-visit',
      label: t`Audience Spend Per Visit`,
      allowsAudience: false,
    },
  ],
  channels: [
    { value: 'channel-total-visits', label: t`Total Visits`, allowsAudience: false },
    { value: 'channel-total-spend', label: t`Total Spend`, allowsAudience: false },
    {
      value: 'channel-spend-per-visit',
      label: t`Audience Spend Per Visit`,
      allowsAudience: false,
    },
    {
      value: 'channel-target-visits',
      label: t`Audience Visits`,
      allowsAudience: false,
    },
    {
      value: 'channel-target-spend-per-visit',
      label: t`Spend Per Visit`,
      allowsAudience: false,
    },
  ],
});
